var _circle, _g, _circle2, _path, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationLicenseAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "white",
    stroke: "#0F6E8C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6679_17293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.05 21.3958C22.6744 21.3958 25.6125 18.4577 25.6125 14.8333C25.6125 11.209 22.6744 8.27084 19.05 8.27084C15.4256 8.27084 12.4875 11.209 12.4875 14.8333C12.4875 18.4577 15.4256 21.3958 19.05 21.3958Z",
    stroke: "#0F6E8C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4969 20.3552L14.3625 28.8959L19.05 26.0834L23.7375 28.8959L22.6031 20.3459",
    stroke: "#0F6E8C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 27,
    r: 5,
    fill: "#DC2626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0255 24.6587V27.4167",
    stroke: "white",
    strokeWidth: 0.878477,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.02,
    cy: 29.0833,
    r: 0.416667,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6679_17293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.5,
    height: 22.5,
    fill: "white",
    transform: "translate(7.79999 7.33334)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationLicenseAlert);
export default __webpack_public_path__ + "static/media/notification_license_alert.c52e021a2a879931ac974781dd69d1ef.svg";
export { ForwardRef as ReactComponent };